import { AlertOctagon, Ban, Eye, Syringe } from "lucide-react";

function Block({ icon: Icon, title, children, tone = "text-slate-700" }) {
  return (
    <div className="mt-4">
      <p className={`text-[11px] font-bold uppercase tracking-wider flex items-center gap-1.5 ${tone}`}><Icon className="w-3.5 h-3.5" /> {title}</p>
      {children}
    </div>
  );
}

export function ProtocolBody({ p }) {
  return (
    <div data-testid={`protocol-body-${p.id}`} className="text-sm text-slate-800">
      <Block icon={Eye} title="Recognise">
        <ul className="mt-1.5 space-y-1 list-disc pl-5">{p.recognise.map((x, i) => <li key={i}>{x}</li>)}</ul>
      </Block>
      <Block icon={AlertOctagon} title="Do this — in order" tone="text-red-700">
        <ol className="mt-2 space-y-2">
          {p.steps.map((x, i) => (
            <li key={i} className="flex gap-3">
              <span className="shrink-0 w-6 h-6 rounded-full bg-red-600 text-white text-xs font-bold flex items-center justify-center">{i + 1}</span>
              <span className="pt-0.5 leading-relaxed">{x}</span>
            </li>
          ))}
        </ol>
      </Block>
      <Block icon={Syringe} title="Drugs & doses" tone="text-red-700">
        <div className="mt-2 rounded-lg border border-red-200 overflow-hidden" data-testid={`protocol-drugs-${p.id}`}>
          {p.drugs.map((d, i) => (
            <div key={i} className="grid sm:grid-cols-[1.3fr_1fr_0.9fr] gap-x-3 gap-y-0.5 px-3 py-2 odd:bg-red-50/60 bg-white text-[13px]">
              <span className="font-semibold text-slate-900">{d.drug}</span>
              <span className="font-bold text-red-700">{d.dose}</span>
              <span className="text-slate-500">{d.who}</span>
            </div>
          ))}
        </div>
      </Block>
      <Block icon={Ban} title="Do not" tone="text-slate-900">
        <ul className="mt-1.5 space-y-1">{p.donts.map((x, i) => <li key={i} className="text-red-800">✕ {x}</li>)}</ul>
      </Block>
      <div className="mt-4 text-xs text-slate-500" data-testid={`protocol-refs-${p.id}`}>
        <p className="font-semibold uppercase tracking-wider">References</p>
        <ol className="mt-1 list-decimal pl-4 space-y-0.5 italic">{p.refs.map((r, i) => <li key={i}>{r}</li>)}</ol>
      </div>
    </div>
  );
}
